/*
 * @Author: your name
 * @Date: 2021-02-26 11:20:24
 * @LastEditTime: 2021-04-13 14:04:20
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /ecmp5-client-web/src/main.js
 */
import App from './App.vue'
import router from './router'
import { createApp } from 'vue';
import Store from '@/store/index'
import filters from '@/filters'
import "@/mock/index.js";
import 'default-passive-events'
import * as Sentry from "@sentry/vue"

console.log("the environment is ->",process.env.NODE_ENV)

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: "https://170572723cdf170a08f58b0e29500c69@sentry.lcola.cn/23",
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        }),
      ],
      beforeSend(event, hint) {
        const error = hint.originalException || hint.syntheticException;
        if (error && error.response && error.response.status === 403) {
          return null; // 忽略 403 错误
        }
        return event;
      },
      // Performance Monitoring
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: [/^https:\/\/.*\.lcola\.cn/],
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })
}

import {
  NavBar,
  Button,
  List,
  SwipeCell,
  Overlay,
  Swipe, SwipeItem,
  Tabbar, TabbarItem,
  Tab, Tabs,
  RadioGroup, Radio,
  Checkbox,
  NoticeBar,
  DatetimePicker,
  Grid, GridItem,
  IndexBar, IndexAnchor,
  Tag,
  Field,
  CellGroup,
  Empty,
  Sticky,
  Popup,
  Cell,
  PasswordInput,
  NumberKeyboard,
  DropdownMenu, DropdownItem,
  PullRefresh
} from 'vant';
const app = createApp(App);
app.config.globalProperties.$filters = filters


router.beforeEach((to, from, next)=>{
  if(to.meta.title){
    document.title = to.meta.title
  }
  next()
})

app.use(NavBar)
  .use(Button)
  .use(Tabbar)
  .use(TabbarItem)
  .use(List)
  .use(Sticky)
  .use(Popup)
  .use(Swipe)
  .use(SwipeCell)
  .use(Tag)
  .use(SwipeItem)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Tab)
  .use(PullRefresh)
  .use(Empty)
  .use(Tabs)
  .use(DatetimePicker)
  .use(IndexBar)
  .use(IndexAnchor)
  .use(Checkbox)
  .use(RadioGroup)
  .use(Radio)
  .use(Cell)
  .use(Grid)
  .use(NoticeBar)
  .use(GridItem)
  .use(CellGroup)
  .use(Field)
  .use(Overlay)
  .use(PasswordInput)
  .use(NumberKeyboard)
  .use(Store)
  .use(router).mount('#app')
